import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.dv-plast.com';
const OG_IMAGE = `${SITE_URL}/img/intro-bg.webp`;

const META = {
  bg: {
    title: 'ДВ Пласт — Дограма, врати и щори | DV Plast, България',
    description:
      'Производство и монтаж на висококачествена PVC и алуминиева дограма, входни и интериорни врати, гаражни врати и щори. Над 10 години опит в България.',
    ogTitle: 'ДВ Пласт — Дограма, врати и щори',
    ogDescription:
      'Производство и монтаж на висококачествена дограма, входни врати, интериорни врати, гаражни врати и щори в България.',
    ogLocale: 'bg_BG',
    ogLocaleAlt: 'en_US',
  },
  en: {
    title: 'DV Plast — Windows, Doors & Blinds | Bulgaria',
    description:
      'Manufacturing and installation of premium PVC and aluminium windows, entrance and interior doors, garage doors and blinds. Over 10 years of experience in Bulgaria.',
    ogTitle: 'DV Plast — Windows, Doors & Blinds',
    ogDescription:
      'Manufacturing and installation of premium windows, entrance doors, interior doors, garage doors and blinds across Bulgaria.',
    ogLocale: 'en_US',
    ogLocaleAlt: 'bg_BG',
  },
};

export const SEO = ({ language = 'bg' }) => {
  const meta = META[language] || META.bg;

  return (
    <Helmet>
      <html lang={language === 'bg' ? 'bg' : 'en'} />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />

      <meta property="og:title" content={meta.ogTitle} />
      <meta property="og:description" content={meta.ogDescription} />
      <meta property="og:locale" content={meta.ogLocale} />
      <meta property="og:locale:alternate" content={meta.ogLocaleAlt} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:secure_url" content={OG_IMAGE} />

      <meta name="twitter:title" content={meta.ogTitle} />
      <meta name="twitter:description" content={meta.ogDescription} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};

export default SEO;
